/**
 * @fileoverview O acesso da pessoa na empresa ativa, para as telas mostrarem só
 * o que a API aceita (GET /auth/access): o modo da regra de acesso e, com a
 * regra nova ligada, as permissões do catálogo. Sem ela, cada tela segue a
 * regra de hoje daquele ponto (o "permitido antes" que ela passa ao can, como
 * no backend). Fica fora do AuthContext porque o QueuesProvider fica acima do
 * AuthProvider.
 */

import create from "zustand";
import api from "../services/api";

// loadedAt: quando o acesso foi lido pela última vez (a releitura no foco espera um pouco entre uma e outra).
// departments: vê os números de algum departamento (o filtro do Dashboard e, na
// regra de hoje, o próprio Dashboard).
const EMPTY = { mode: "legacy", granted: [], ticketsView: null, departments: false, loaded: false, loadedAt: 0 };

// Uma leitura por vez: pedida de novo no meio de outra, a nova sai quando a
// primeira termina (vale a resposta mais nova). Sair (clear) descarta a que
// estiver no caminho, que era da sessão anterior.
let reading = null;
let readAgain = false;
let session = 0;

const usePermissionStore = create((set, get) => ({
  ...EMPTY,

  // Lê o acesso de agora (no login, na troca de empresa, quando a API nega, no
  // aviso de que ele mudou, no foco e a cada 5 minutos: hooks/useAuth.js).
  load: () => {
    if (reading) {
      readAgain = true;
      return reading;
    }
    const current = session;
    reading = (async () => {
      try {
        const { data } = await api.get("/auth/access");
        if (current !== session) return;
        set({
          mode: data?.mode || "legacy",
          granted: Array.isArray(data?.granted) ? data.granted : [],
          ticketsView: data?.ticketsView || null,
          departments: data?.departments === true,
          loaded: true,
          loadedAt: Date.now(),
        });
      } catch (err) {
        // Sem resposta: fica o que já tinha (de início, a regra de hoje), e as
        // rotas decidem com ele.
        if (current === session) set({ loaded: true });
      } finally {
        reading = null;
        if (readAgain) {
          readAgain = false;
          get().load();
        }
      }
    })();
    return reading;
  },

  clear: () => {
    session += 1;
    readAgain = false;
    set(EMPTY);
  },
}));

export default usePermissionStore;
